import {
  notify
} from "./chunk-DL5QNKBI.js";
import {
  PAGE_STATUS
} from "./chunk-OSVSI4BW.js";
import {
  __publicField
} from "./chunk-6FER3ETN.js";

// src/pages/MemberRole/MemberRoleViewModel/MemberRoleDetailViewModel.ts
import { MEMBER_ROLE_FIELD } from "aesirx-lib";
import { makeAutoObservable, runInAction } from "mobx";
var MemberRoleDetailViewModel = class {
  constructor(memberRoleStore) {
    __publicField(this, "memberRoleStore");
    __publicField(this, "formStatus", PAGE_STATUS.READY);
    __publicField(this, "memberRoleDetailViewModel", { formPropsData: [{}] });
    __publicField(this, "aliasChange", "");
    __publicField(this, "memberRoleList", []);
    __publicField(this, "successResponse", {
      state: true,
      content_id: "",
      filters: {}
    });
    __publicField(this, "setForm", (memberRoleDetailViewModel) => {
      this.memberRoleDetailViewModel = memberRoleDetailViewModel;
    });
    __publicField(this, "initializeData", async () => {
      this.formStatus = PAGE_STATUS.LOADING;
      const data = await this.memberRoleStore.getDetail(
        this.memberRoleDetailViewModel.formPropsData[MEMBER_ROLE_FIELD.ID]
      );
      runInAction(() => {
        if (!data?.error) {
          this.onGetMemberRoleSuccessHandler(data?.response);
        } else {
          this.onErrorHandler(data?.response);
        }
      });
    });
    __publicField(this, "getMemberRoleList", async () => {
      this.formStatus = PAGE_STATUS.LOADING;
      const data = await this.memberRoleStore.getMemberRoleList(this.successResponse.filters);
      runInAction(() => {
        if (!data?.error) {
          this.onGetMemberRoleListSuccessHandler(data?.response);
        } else {
          this.onErrorHandler(data?.response);
        }
      });
    });
    __publicField(this, "create", async () => {
      this.formStatus = PAGE_STATUS.LOADING;
      const data = await this.memberRoleStore.create(this.memberRoleDetailViewModel.formPropsData);
      runInAction(() => {
        if (!data?.error) {
          this.onSuccessHandler(data?.response, "Created successfully");
        } else {
          this.onErrorHandler(data?.response);
        }
      });
      return data;
    });
    __publicField(this, "update", async () => {
      this.formStatus = PAGE_STATUS.LOADING;
      const data = await this.memberRoleStore.update(this.memberRoleDetailViewModel.formPropsData);
      runInAction(() => {
        if (!data?.error) {
          this.onSuccessHandler(data?.response, "Updated successfully");
        } else {
          this.onErrorHandler(data?.response);
        }
      });
      return data;
    });
    __publicField(this, "onErrorHandler", (error) => {
      error._messages[0]?.message ? notify(error._messages[0]?.message, "error") : error.message && notify(error.message, "error");
      this.successResponse.state = false;
      this.successResponse.content_id = error.result;
      this.formStatus = PAGE_STATUS.READY;
    });
    __publicField(this, "onSuccessHandler", (result, message) => {
      if (result && message) {
        notify(message, "success");
      }
      this.formStatus = PAGE_STATUS.READY;
    });
    __publicField(this, "onGetMemberRoleSuccessHandler", (result) => {
      if (result && result[MEMBER_ROLE_FIELD.ID]) {
        this.memberRoleDetailViewModel.formPropsData = {
          ...this.memberRoleDetailViewModel.formPropsData,
          ...Object.keys(MEMBER_ROLE_FIELD).map((index) => {
            return {
              [MEMBER_ROLE_FIELD[index]]: result[MEMBER_ROLE_FIELD[index]]
            };
          }).reduce((prev, cur) => ({ ...prev, ...cur }))
        };
        this.formStatus = PAGE_STATUS.READY;
      }
    });
    __publicField(this, "onGetMemberRoleListSuccessHandler", (result) => {
      if (result) {
        this.memberRoleList = result;
      }
      this.formStatus = PAGE_STATUS.READY;
    });
    __publicField(this, "handleFormPropsData", (key, value) => {
      if (key && value !== null) {
        if (typeof value === "object" && value !== null && !Array.isArray(value)) {
          Object.assign(this.memberRoleDetailViewModel.formPropsData[key], value);
        } else {
          this.memberRoleDetailViewModel.formPropsData[key] = value;
        }
      }
    });
    __publicField(this, "handleAliasChange", (value) => {
      this.aliasChange = value;
    });
    makeAutoObservable(this);
    this.memberRoleStore = memberRoleStore;
  }
};
var MemberRoleDetailViewModel_default = MemberRoleDetailViewModel;

export {
  MemberRoleDetailViewModel_default
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
